import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveFilter as _resolveFilter, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "modern-video-card"
};
const _hoisted_2 = {
  class: "modern-video-thumb-wrap"
};
const _hoisted_3 = {
  class: "modern-video-thumb-overlay"
};
const _hoisted_4 = {
  class: "modern-play-button"
};
const _hoisted_5 = {
  key: 1,
  class: "modern-featured-badge"
};
const _hoisted_6 = {
  class: "modern-video-body"
};
const _hoisted_7 = {
  class: "modern-video-topbar"
};
const _hoisted_8 = {
  class: "modern-video-title-wrap"
};
const _hoisted_9 = {
  class: "modern-video-title"
};
const _hoisted_10 = {
  key: 0,
  class: "modern-video-submeta"
};
const _hoisted_11 = {
  class: "modern-owner-line"
};
const _hoisted_12 = {
  class: "modern-ensemble-line"
};
const _hoisted_13 = {
  key: 1,
  class: "modern-tag-row"
};
const _hoisted_14 = ["href"];
const _hoisted_15 = {
  class: "modern-tag-more"
};
const _hoisted_16 = {
  class: "modern-video-actions"
};
const _hoisted_17 = ["title"];
const _hoisted_18 = ["title"];
const _hoisted_19 = {
  class: "modern-video-info-panel"
};
const _hoisted_20 = {
  class: "modern-video-description"
};
const _hoisted_21 = {
  class: "mb-0"
};
const _hoisted_22 = {
  class: "modern-program-link"
};
const _hoisted_23 = ["href"];
const _hoisted_24 = {
  class: "mb-1 modern-comp-title"
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  key: 1
};
const _hoisted_27 = {
  key: 0,
  class: "list-inline mb-0 small"
};
const _hoisted_28 = {
  key: 1,
  class: "list-inline mb-0 small"
};
const _hoisted_29 = {
  class: "list-inline-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = _resolveComponent("b-icon");
  const _component_b_img = _resolveComponent("b-img");
  const _component_b_badge = _resolveComponent("b-badge");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_input_group_append = _resolveComponent("b-input-group-append");
  const _component_b_input_group = _resolveComponent("b-input-group");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  const _component_b_overlay = _resolveComponent("b-overlay");
  const _directive_b_popover = _resolveDirective("b-popover");
  const _filter_stringMax = _resolveFilter("stringMax");
  return _openBlock(), _createBlock(_component_b_overlay, {
    show: _ctx.favoriteLoading,
    opacity: "0.6",
    "spinner-variant": "primary",
    "no-fade": "",
    rounded: "",
    class: "video-card-overlay"
  }, {
    default: _withCtx(() => [_createElementVNode("article", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!$props.video.noView ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      class: "modern-video-thumb-link",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.$emit('play'), ["prevent"])),
      href: ""
    }, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_b_icon, {
      icon: "play-fill"
    })])), [[_directive_b_popover, !$props.preview ? 'Watch Now' : 'Subscribe To Watch', void 0, {
      hover: true,
      top: true
    }]])])])) : _createCommentVNode("", true), $props.video.video.featured > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Featured ")) : _createCommentVNode("", true), $props.video.thumbError ? (_openBlock(), _createBlock(_component_b_img, {
      key: 2,
      src: "https://placehold.it/960x550?text=Spin+Network",
      class: "modern-video-thumb",
      alt: $props.video.video.title
    }, null, 8, ["alt"])) : (_openBlock(), _createBlock(_component_b_img, {
      key: 3,
      src: $props.video.thumbnail_link,
      class: "modern-video-thumb",
      title: $props.video.video.title,
      alt: $props.video.video.title
    }, null, 8, ["src", "title", "alt"]))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("h5", _hoisted_9, _toDisplayString(_filter_stringMax($props.video.video.title, 60)), 1), _withDirectives(_createVNode(_component_b_badge, {
      variant: "primary",
      class: "modern-new-badge"
    }, {
      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" NEW ", -1)]))], undefined, true),
      _: 1
    }, 512), [[_vShow, $props.video.new]])]), _createVNode(_component_b_dropdown, {
      "toggle-class": "text-decoration-none modern-video-menu-toggle",
      placement: "bottom-end",
      "no-caret": "",
      variant: "link",
      size: "sm",
      class: "modern-video-menu"
    }, {
      "button-content": _withCtx(() => [_createVNode(_component_b_icon, {
        icon: "three-dots-vertical"
      })]),
      default: _withCtx(() => [!$props.preview ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
        key: 0,
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.favorite(), ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_b_icon, {
          icon: _ctx.localFavorite ? 'heart-fill' : 'heart'
        }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_ctx.localFavorite ? 'Remove Favorite' : 'Add Favorite'), 1)], undefined, true),
        _: 1
      })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_b_dropdown_item, {
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => _ctx.showInfo = 1, ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_b_icon, {
          icon: "info-circle-fill"
        }), _cache[8] || (_cache[8] = _createTextVNode(" Video Info ", -1))], undefined, true),
        _: 1
      }, 512), [[_vShow, _ctx.showInfo !== 1]]), !$props.preview ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
        key: 1,
        href: '/video/watch/' + $props.video.id,
        target: "_blank"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_icon, {
          icon: "box-arrow-up-right"
        }), _cache[9] || (_cache[9] = _createTextVNode(" Open In New Window ", -1))], undefined, true),
        _: 1
      }, 8, ["href"])) : _createCommentVNode("", true), !$props.preview ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
        key: 2,
        class: "modern-copy-dropdown"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_input_group, {
          size: "sm"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_form_input, {
            readonly: "",
            modelValue: _ctx.videolink,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.videolink = $event)
          }, null, 8, ["modelValue"]), _createVNode(_component_b_input_group_append, null, {
            default: _withCtx(() => [_createVNode(_component_b_button, {
              size: "sm",
              onClick: _cache[4] || (_cache[4] = $event => $options.copy())
            }, {
              default: _withCtx(() => [_createVNode(_component_b_icon, {
                icon: "clipboard"
              })], undefined, true),
              _: 1
            })], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })) : _createCommentVNode("", true)], undefined, true),
      _: 1
    })]), $props.video.video.ensemble.id !== 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString($props.video.video.ensemble.organization.name), 1), _createElementVNode("div", _hoisted_12, _toDisplayString($props.video.video.ensemble.name), 1), _withDirectives(_createElementVNode("p", {
      class: "modern-video-owner"
    }, " Video Owner: " + _toDisplayString($props.video.video.organization.name), 513), [[_vShow, _ctx.showInfo]])])) : _createCommentVNode("", true), $props.video.video.ensemble.id !== 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [!$props.preview ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 0
    }, _renderList($options.sharedTags, (val, i) => {
      return _withDirectives((_openBlock(), _createElementBlock("a", {
        href: '/video?text_search=' + val.tag,
        key: i,
        class: "modern-tag-link"
      }, [_createVNode(_component_b_badge, {
        pill: "",
        variant: "light",
        class: "modern-tag-badge"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_filter_stringMax(val.tag, 34)), 1)], undefined, true),
        _: 2
      }, 1024)], 8, _hoisted_14)), [[_directive_b_popover, 'Search For', void 0, {
        hover: true,
        top: true
      }]]);
    }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList($options.sharedTags, (val, i) => {
      return _openBlock(), _createElementBlock("span", {
        key: i,
        class: "modern-tag-link"
      }, [_createVNode(_component_b_badge, {
        pill: "",
        variant: "light",
        class: "modern-tag-badge"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_filter_stringMax(val.tag, 34)), 1)], undefined, true),
        _: 2
      }, 1024)]);
    }), 128)), _withDirectives(_createElementVNode("span", _hoisted_15, " ... ", 512), [[_vShow, $props.video.video.sharedTag && $props.video.video.sharedTag.length > 6]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [!$props.video.noView && !$props.preview ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      href: "",
      onClick: _cache[5] || (_cache[5] = _withModifiers($event => $options.favorite(), ["prevent"])),
      class: "modern-icon-action favorite",
      title: _ctx.localFavorite ? 'Remove Favorite' : 'Add Favorite'
    }, [_createVNode(_component_b_icon, {
      icon: _ctx.localFavorite ? 'heart-fill' : 'heart'
    }, null, 8, ["icon"])], 8, _hoisted_17)) : _createCommentVNode("", true), _createElementVNode("a", {
      href: "",
      onClick: _cache[6] || (_cache[6] = _withModifiers($event => _ctx.showInfo = _ctx.showInfo ? 0 : 1, ["prevent"])),
      class: "modern-icon-action",
      title: _ctx.showInfo ? 'Hide Info' : 'Video Info'
    }, [_createVNode(_component_b_icon, {
      icon: _ctx.showInfo ? 'x-circle-fill' : 'info-circle-fill'
    }, null, 8, ["icon"])], 8, _hoisted_18)]), _withDirectives(_createElementVNode("div", _hoisted_19, [_withDirectives(_createElementVNode("div", _hoisted_20, [_createElementVNode("p", _hoisted_21, _toDisplayString($props.video.video.description), 1)], 512), [[_vShow, $props.video.video.description.length > 0]]), _withDirectives(_createElementVNode("div", _hoisted_22, [_createElementVNode("a", {
      href: $props.video.video.programlink,
      target: "_blank"
    }, "Program Link", 8, _hoisted_23)], 512), [[_vShow, $props.video.video.programlink && $props.video.video.programlink !== '' && !$props.preview]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.video.video.ownVideocomposition, vc => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: vc.id,
        class: "modern-comp-card"
      }, [_createElementVNode("p", _hoisted_24, [vc.composition_id > 0 ? (_openBlock(), _createElementBlock("b", _hoisted_25, _toDisplayString(vc.composition.title), 1)) : _createCommentVNode("", true), vc.composition_id == null ? (_openBlock(), _createElementBlock("b", _hoisted_26, _toDisplayString(vc.newtitle), 1)) : _createCommentVNode("", true)]), vc.composition && vc.composition.sharedComposer.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [_cache[10] || (_cache[10] = _createElementVNode("li", {
        class: "list-inline-item"
      }, "Written by:", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vc.composition.sharedComposer, (co, key) => {
        return _openBlock(), _createElementBlock("li", {
          class: "list-inline-item",
          key: key
        }, [_createTextVNode(_toDisplayString(co.name), 1), _withDirectives(_createElementVNode("span", null, ", ", 512), [[_vShow, key !== Object.keys(vc.composition.sharedComposer).length - 1]])]);
      }), 128))])) : _createCommentVNode("", true), vc.composition_id == null && vc.newcomposer !== null ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [_cache[11] || (_cache[11] = _createElementVNode("li", {
        class: "list-inline-item"
      }, "Written by:", -1)), _createElementVNode("li", _hoisted_29, _toDisplayString(vc.newcomposer), 1)])) : _createCommentVNode("", true)])), [[_vShow, $props.video.video.ensemble.id !== 1 && !$props.preview]]);
    }), 128))], 512), [[_vShow, _ctx.showInfo == 1]])])])], undefined, true),
    _: 1
  }, 8, ["show"]);
}